import { apiPost } from "../client";
import useLoginStore from "../../stores/loginStore";

export interface IApiLoginProps {
  email: string;
  password: string;
}

export interface ILoginResponse {
  token: string;
}

export const apiLogin = async (props: IApiLoginProps) => {
  const response = await apiPost<ILoginResponse>("/auth/login", props);

  // 로그인 성공 시 토큰을 스토어에 저장
  if (response.success && response.data?.token) {
    useLoginStore.getState().setToken(response.data.token);
  }

  return response;
};
